import { render, staticRenderFns } from "./RequestView.vue?vue&type=template&id=2d4caec0"
import script from "./RequestView.vue?vue&type=script&lang=js"
export * from "./RequestView.vue?vue&type=script&lang=js"
import style0 from "./RequestView.vue?vue&type=style&index=0&id=2d4caec0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports